import styled from 'styled-components';

export const MenuButtonStyle = styled.button`
  all: unset;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;        /* 🚀 prevents shrinking/stretching */
  border-radius: 6px;
  color: #aaa; /* default icon color */
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: #e5e5e5;
  }
`;